// الجهاز يقول أين هو لـ«أجهزتي» (قرار المالك 06/10/2026: «محتاج ازود اللوكيشن واسم المدينة… اعمل كل حاجه ادق وافضل»، ثم «وحط
// كمان الدبوس ال اتفتح منه اللوكيشن اخر مره»). يُحفظ على الخادم آخر نقطةٍ للجهاز وحدها (0194/0195 — لا سجلّ حركة) لدبوس الخريطة.
//
// مرّةً واحدة في تحميل الصفحة، وفقط حين يطلبها الخادم (`me.needsLocation`: لم يُرسل هذا الجهاز موقعه خلال 6 ساعات، وملف المدن
// موجود على الخادم) — **وفقط إن كان إذن الموقع ممنوحًا من قبل** (المراجعة الثالثة 06/10/2026): كان يسأل «تسمح بالموقع؟» عند
// فتح الصفحة بلا سبب يراه الموظف، فمن رفض أو أغلق السؤال مرّاتٍ يمنع المتصفّح الموقع عن البرنامج كلّه — والبصمة تحتاجه وتُرفض
// بدونه. فالسؤال الأوّل يبقى للبصمة وحدها (يضغط الموظف فيُسأل)، وهنا يُقرأ الموقع بصمت حيث الإذن قائم. ومن لم يمنحه بعد تبقى له
// المدينة التقريبية من عنوان الإنترنت.
import { useEffect, useRef } from 'react';
import { post, type Me } from '../lib/api.ts';
import { tapLocation } from '../attendance/geo.ts';

/** هل إذن الموقع ممنوحٌ الآن؟ — بلا سؤال. ومتصفّحٌ لا يجيب (أو تطبيقٌ بلا الواجهة) يُعدّ «لا» */
export async function locationAlreadyGranted(): Promise<boolean> {
  try {
    const perms = (navigator as Navigator & { permissions?: Permissions }).permissions;
    if (!perms?.query) return false;
    const st = await perms.query({ name: 'geolocation' as PermissionName });
    return st.state === 'granted';
  } catch { return false; }
}

export function useReportDeviceLocation(me: Me | null): void {
  const sent = useRef(false);
  useEffect(() => {
    if (!me || me.mustChangePassword || me.needsLocation !== true || sent.current) return;
    sent.current = true;
    void (async () => {
      try {
        if (!(await locationAlreadyGranted())) return;
        const b = await tapLocation();
        if (b.locationMissing || b.gpsLat == null || b.gpsLon == null) return;
        await post('/me/sessions/location', {
          lat: b.gpsLat, lon: b.gpsLon,
          ...(b.gpsAccuracyM != null ? { accuracyM: b.gpsAccuracyM } : {}),
          ...(b.mockLocation === true ? { mock: true } : {}),
        });
      } catch { /* المكان مساعدٌ لا شرط — لا رسالة على الشاشة */ }
    })();
  }, [me]);
}
